import { configureStore } from '@reduxjs/toolkit';
import createRootReducer from './ducks/rootReducer';

const store = configureStore({
  reducer: createRootReducer(),
});

export default store;